<section>
    <!-- Nothing to show here because all this page does is open the view document dialog modal -->
</section>